import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-book',
  templateUrl: './account-book.component.html',
  styleUrls: ['./account-book.component.scss']
})
export class AccountBookComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
